<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="container-fluid"
    *ngIf="!hasPendingData && data != null"
>
    <div class="row">
        <div class="col-12 p-0">
            <ng-chart-horizontal
                [options]="options"
                [data]="data.d3.data"
            ></ng-chart-horizontal>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-right mt-3 p-0">
            <button
                type="button"
                class="btn btn-primary"
                (click)="showDetails()"
            >
                {{ i18n._746_DETAILS | translate }}
            </button>
        </div>
    </div>
</div>
